<template>
  <div class="section container">
    <div class="box">
      <h1 class="title is-primary">Resume</h1>
    </div>
    <div class="box">
      <div class="tabs is-centered">
        <ul>
          <li
            v-bind:class="{ 'is-active': tab == 'education' }"
            @click="tab = 'education'"
          >
            <a>Education</a>
          </li>
          <li
            v-bind:class="{ 'is-active': tab == 'skills' }"
            @click="tab = 'skills'"
          >
            <a>Skills</a>
          </li>
          <li
            v-bind:class="{ 'is-active': tab == 'certifications' }"
            @click="tab = 'certifications'"
          >
            <a>Certifications</a>
          </li>
          <li
            v-bind:class="{ 'is-active': tab == 'jobs' }"
            @click="tab = 'jobs'"
          >
            <a>Jobs</a>
          </li>
          <li
            v-bind:class="{ 'is-active': tab == 'volunteer' }"
            @click="tab = 'volunteer'"
          >
            <a>Volunteering</a>
          </li>
          <li
            v-bind:class="{ 'is-active': tab == 'awards' }"
            @click="tab = 'awards'"
          >
            <a>Awards</a>
          </li>
        </ul>
      </div>
      <div class="content">
        <!--EDUCATION-->
        <div v-show="tab == 'education'">
          <ul>
            <li v-for="education in education" :key="education.id">
              <div class="box has-link">
                <h5 class="title">{{ education.title }}</h5>
                {{ education.location }} - {{ education.date }},
                {{ education.gpa }}GPA
              </div>
            </li>
          </ul>
        </div>
        <!--Skills-->
        <div v-show="tab == 'skills'">
          <ul class="section up">
            <li v-for="skills in skills" :key="skills.id">
              <div class="box has-link">
                {{ skills.info }}
              </div>
            </li>
          </ul>
        </div>
        <!--Certifications-->
        <div v-show="tab == 'certifications'">
          <ul class="section up">
            <li v-for="certification in certification" :key="certification.id">
              <div class="box has-link">
                <h5>{{ certification.certificate }}</h5>
                {{ certification.date }}
              </div>
            </li>
          </ul>
        </div>
        <!--JOBS-->
        <div v-show="tab == 'jobs'">
          <ul class="section up">
            <li v-for="jobs in jobs" :key="jobs.id">
              <div class="box has-link">
                <h5>{{ jobs.title }}</h5>
                <div class="septop">
                  {{ jobs.company }} - {{ jobs.location }}
                </div>
                <div class="sepbot">{{ jobs.date }}</div>
                <span class="pw">{{ jobs.info }}</span>
              </div>
            </li>
          </ul>
        </div>
        <!--VOLUNTEER-->
        <div v-show="tab == 'volunteer'">
          <ul class="section up">
            <li v-for="volunteer in volunteer" :key="volunteer.id">
              <div class="box has-link">
                <h5>{{ volunteer.title }}</h5>
                <div class="sep">
                  {{ volunteer.company }} - {{ volunteer.location }}
                </div>
                <div>{{ volunteer.date }}</div>
                <br />
                <span class="pw">{{ volunteer.info }}</span>
              </div>
            </li>
          </ul>
        </div>
        <!--AWARDS-->
        <div v-show="tab == 'awards'">
          <ul class="section up">
            <li v-for="awards in awards" :key="awards.id">
              <div class="box has-link">
                <h5>{{ awards.title }}</h5>
                {{ awards.date }}
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "Resume",
  metaInfo: {
    title: "Resume",
    titleTemplate: "%s - Meet John",
    meta: [
      {
        name: "Resume",
        content: "Resume of John Nguyen"
      }
    ]
  },

  data: function() {
    return {
      tab: "education",
      apiKey: process.env.VUE_APP_KEY,
      apiUrl: process.env.VUE_APP_URL,
      education: [],
      skills: [],
      certification: [],
      jobs: [],
      volunteer: [],
      awards: []
    };
  },

  async created() {
    try {
      const url = `${this.apiUrl}/education.json?auth=${this.apiKey}`;
      const res = await axios.get(url);

      this.education = res.data;
    } catch (e) {
      console.error(e);
    }

    try {
      const url = `${this.apiUrl}/skills.json?auth=${this.apiKey}`;
      const res = await axios.get(url);

      this.skills = res.data;
    } catch (e) {
      console.error(e);
    }

    try {
      const url = `${this.apiUrl}/certification.json?auth=${this.apiKey}`;
      const res = await axios.get(url);

      this.certification = res.data;
    } catch (e) {
      console.error(e);
    }

    try {
      const url = `${this.apiUrl}/jobs.json?auth=${this.apiKey}`;
      const res = await axios.get(url);

      this.jobs = res.data;
    } catch (e) {
      console.error(e);
    }

    try {
      const url = `${this.apiUrl}/volunteer.json?auth=${this.apiKey}`;
      const res = await axios.get(url);

      this.volunteer = res.data;
    } catch (e) {
      console.error(e);
    }

    try {
      const url = `${this.apiUrl}/awards.json?auth=${this.apiKey}`;
      const res = await axios.get(url);

      this.awards = res.data;
    } catch (e) {
      console.error(e);
    }
  }
};
</script>

<style lang="scss">
.box {
  padding-top: 2rem;
  padding-bottom: 2rem;
}
li {
  list-style: none;
}
ul {
  margin: 0px;
  padding-top: 1rem;
}
.up {
  padding-top: 0rem;
}
.content {
  align-items: center;
}
.septop {
  padding-top: 0rem;
}
.sepbot {
  padding-bottom: 1rem;
}
.pw {
  white-space: pre-wrap;
}
</style>
